import { Injectable } from '@angular/core';
import {
  AuthenticatedResult,
  LoginResponse,
  OidcSecurityService,
  UserDataResult,
} from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { User } from 'src/app/@core/domain/models/user.model';
import { ParkbaseStorageService } from 'src/app/@shared/services/parkbaseStorage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private user!: User;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private parkbaseStorageService: ParkbaseStorageService
  ) {}

  get theService(): OidcSecurityService {
    return this.oidcSecurityService;
  }

  get isLoggedIn(): Observable<AuthenticatedResult> {
    return this.oidcSecurityService.isAuthenticated$;
  }

  get IdToken(): string {
    return this.oidcSecurityService.getIdToken();
  }

  get userData(): Observable<UserDataResult> {
    return this.oidcSecurityService.userData$;
  }

  setCredentials(): void {
    let storageKey = '';
    this.userData.subscribe((result: UserDataResult) => {
      if (result && result.userData && !this.user) {
        const u = result.userData;
        const existingUserData = this.parkbaseStorageService.retrieveUserSessionId();
        if (existingUserData && existingUserData.key && existingUserData.key.length > 0) {
          storageKey = existingUserData.key;
        }
        this.user = new User(
          storageKey.length > 0 ? storageKey : u.sub.split('-')[0],
          u.lastlogindate,
          u.preferred_username,
          u.email,
          this.oidcSecurityService.getAccessToken(),
          u.role
        );
        this.parkbaseStorageService.storeUserSessionId(this.user);
      }
    });
  }

  getUser() {
    return this.user;
  }

  clearCredentials(): void {
    this.oidcSecurityService.revokeAccessToken();
  }

  checkAuth(): Observable<LoginResponse> {
    return this.oidcSecurityService.checkAuth();
  }

  doLogin(): Observable<void> {
    return of(this.oidcSecurityService.authorize());
  }

  signOut(): Observable<boolean> {
    const config = this.oidcSecurityService.getConfigurations()[0];
    this.clearCredentials();
    this.oidcSecurityService.logoffLocal(config.configId);
    return of(true);
  }

  onTokenChange(): Observable<boolean> {
    return this.oidcSecurityService.checkSessionChanged$;
  }
}
